module.exports = __webpack_public_path__ + "img/HealthHelp_Videos.70808549.svg";